export default function createInputGroup(referenceElement) {
  const elements = new Set([referenceElement])

  return {
    ref() {
      return referenceElement
    },
    add(items) {
      items.forEach((item) => {
        elements.add(item)
      })
    },
    call(name, ...args) {
      elements.forEach((element) => {
        element[name](...args)
      })
    },
    callRef(name, ...args) {
      return referenceElement[name](...args)
    },
    prop(name) {
      return referenceElement[name]
    },
    someProp(name, cb) {
      return [...elements].some((element) => cb(element[name]))
    },
    everyProp(name, cb) {
      return [...elements].every((element) => cb(element[name]))
    },
  }
}
